type AddToBasketType = {
  sku: string;
  promocode: string;
  qty: number;
  price: number;
  basketItems: BasketItem[];
};

type BasketItem = {
  sku: string;
  qty: number;
  price: number;
};
// This method expects basketItems to contain the item that was just added
export const addToBasket = ({ sku, promocode, qty, price, basketItems }: AddToBasketType) => {
  if (!global.DY) {
    console.error(`Dynamic Yield Error: DY is not defined`);
    return;
  }

  global.DY.API('event', {
    name: 'Add to Cart',
    properties: {
      dyType: 'add-to-cart-v1',
      value: price * qty,
      // The DY product feed does not permit spaces in SKUs. SKUs sent in events should match those sent in the feed exactly.
      productId: promocode ? `${sku}_${promocode}` : sku,
      quantity: qty,
      cart: basketItems.map(({ sku, qty, price }) => ({
        productId: sku.replace(' ', '_'),
        quantity: qty,
        itemPrice: price,
      })),
    },
  });
};
